import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { UserService } from '../shared/services/user.service';
import Swal from 'sweetalert2'
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { MetaTagsService } from '../shared/services/meta-tags.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { YouTubePlayer } from '@angular/youtube-player';
import { WindowRefService } from '../shared/services/window-ref.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  form: UntypedFormGroup
  formValues: any
  submitting = false
  hasError = false
  apiLoaded = false
  youtubeHeight: number | undefined
  youtubeWidth: number | undefined
  @ViewChild('youTubePlayerEl') youTubePlayer: ElementRef<HTMLDivElement>
  @ViewChild('youTubeCol') youTubeCol: ElementRef<HTMLDivElement>
  @ViewChild(YouTubePlayer) youtubePlayerComponent!: YouTubePlayer
  schema: any
  private subs = new Subscription()
  constructor(
    private fb: UntypedFormBuilder,
    private tsService: Title,
    private metaService: Meta,
    private userService: UserService,
    private tagsService: MetaTagsService,
    private renderer: Renderer2, @Inject(DOCUMENT) private _document: any,
    @Inject(PLATFORM_ID) private platformId: Object,
    private cd: ChangeDetectorRef,
    private windowRef: WindowRefService
  ) {
    // this.getScreenSize()
    if (isPlatformBrowser(this.platformId) && !this.apiLoaded) {
      const youtubeScriptTag = this.renderer.createElement('script')
      youtubeScriptTag.type = 'text/javascript'
      youtubeScriptTag.src = 'https://www.youtube.com/iframe_api'
      this.renderer.appendChild(this._document.body, youtubeScriptTag)
      this.apiLoaded = true
    }
  }

  ngOnInit(): void {
    this.setUpSeo()
    this.createFormValues()
    this.createForm()
  }

  ngAfterViewInit(): void {
    this.onResize()
    if (isPlatformBrowser(this.platformId)) {
      this.windowRef.nativeWindow.window.addEventListener('resize', this.onResize)
    }
  }

  onResize = (): void => {
    this.youtubeWidth = this.youTubeCol.nativeElement.clientWidth - 20
    // Automatically expand the video to fit the page up to 1200px x 720px
    // this.youtubeWidth = Math.min(this.youTubePlayer['youtubeContainer'].nativeElement.clientWidth, 1200);
    this.youtubeHeight = this.youtubeWidth * 0.6
    this.cd.detectChanges()
  }

  onPlayerReady(event: any) {
    // if (event && event.target.G.onReady === true) {
    //   // event.target.playVideo()
    //   this.youtubePlayerComponent.playVideo()
    // }
  }

  setUpSeo() {
    const title = 'IHM Used Parts | Home'
    this.tsService.setTitle(title)
    const tags = [
      { property: 'og:image', content: `${environment.webUrl}/assets/images/ihm-used-parts-og.png` },
      { property: 'og:title', content: title },
      { property: 'og:type', content: 'website' },
      { property: 'og:description', content: environment.webDescription },
      { property: 'description', content: environment.webDescription }
    ]
    tags.forEach(x => {
      this.metaService.updateTag(x)
    })
    this.tagsService.setCurrentTags(tags)
  }

  createFormValues() {
    this.formValues = {
      name: ['', Validators.compose([Validators.required])],
      email: ['', Validators.compose([Validators.required])]
    }
  }

  createForm() {
    this.form = this.fb.group(this.formValues)
  }

  // convenience getter for form controls
  get f() {
    if (this.form && this.form.controls) {
      return this.form.controls
    }
  }

  submitForm() {
    this.submitting = true
    if (!this.form.valid) {
      this.submitting = false
      return
    }
    const params = this.cleanFormInput(this.form.value)
    this.subs.add(
      this.userService.subscribeToMailingList(params).subscribe(data => {
        if (data) {
          Swal.fire({
            title: 'Thank You for Subscribing!',
            icon: 'success',
            timer: 3000,
            showConfirmButton: false
          }).then(() => {
            this.submitting = false
          })
        }
      }, error => {
        if (error) {
          Swal.fire({
            title: 'Error!',
            text: error.msg ? error.msg : 'Something Went Wrong',
            icon: 'error',
            timer: 2000,
            showConfirmButton: false
          }).then(() => {
            this.hasError = true
            this.submitting = false
            console.error(error)
          })
        }
      })
    )
  }

  cleanFormInput(form: any) {
    // TODO: Implement Some Way To Clean Before Sending To Service
    return form
  }

  ngOnDestroy() {
    this.subs.unsubscribe()
    if (isPlatformBrowser(this.platformId)) {
      this.windowRef.nativeWindow.window.removeEventListener('resize', this.onResize)
    }
  }

}
